import { Podcast } from '@models/Podcast';
import React from 'react';

function PodcastIntroTab(props: { podcast: Podcast }) {
  const { podcast } = props;

  return (
    <div>
      <div className="section-6">
        <div className="container-3 w-container">
          <div className="panel-base flex-grow">
            <div className="section-title-wrap">
              <h4 className="section-title">關於</h4>
              <div className="section-title-underline" />
            </div>
            <p
              className="section-body-text"
              dangerouslySetInnerHTML={{
                __html: podcast.description
                  .replace(/\n/g, '<br />')
              }} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PodcastIntroTab;
